"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSeoOverview() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tickerItems = ["WEBSITE DESIGN", "SEO STRATEGY", "LOCAL LISTINGS", "GROWTH ENGINE", "PRECISION", "WEBSITE DESIGN", "SEO STRATEGY", "LOCAL LISTINGS", "GROWTH ENGINE", "PRECISION"];
  return <section data-section-id="1285" id="hero-seo-overview" className="relative text-foreground min-h-screen w-full overflow-hidden flex items-center justify-center py-0 light bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704907/img/asahi_hero_office.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704907/img/asahi_hero_office.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704907/img/asahi_hero_office.webp-wvc-sizes" alt="Modern office workspace for digital agency" className="h-full w-full object-cover opacity-20" loading="eager" decoding="async" />
        <div className="absolute inset-0 bg-background/80" />
        {}
        <div className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
      }} />
      </div>

      {}
      <div className="absolute top-20 md:top-24 left-0 right-0 z-20 overflow-hidden border-y border-border">
        <div className="flex whitespace-nowrap py-3 animate-[ticker_40s_linear_infinite] hover:[animation-play-state:paused]">
          {tickerItems.concat(tickerItems).map((item, i) => <div key={i} data-index={i} className="flex items-center shrink-0">
              <span className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground px-6">
                {item}
              </span>
              <span className="size-1.5 bg-primary shrink-0" aria-hidden="true" />
            </div>)}
        </div>
      </div>

      {}
      <div aria-hidden="true" className="absolute bottom-0 -right-8 md:right-0 z-10 pointer-events-none select-none leading-none" style={{
      fontFamily: "var(--font-sans)",
      fontSize: "clamp(18rem, 32vw, 36rem)",
      color: "hsl(200 70% 55% / 0.04)",
      letterSpacing: "-0.02em"
    }}>
        01
      </div>

      {}
      <div className="relative z-30 w-full max-w-[1600px] px-6 md:px-12 lg:px-16 pt-32 pb-32 md:pt-40 md:pb-40">
        {}
        <div className="flex items-center gap-3 mb-12 md:mb-16">
          
          <span className="h-px w-10 bg-border" aria-hidden="true" />
        </div>

        {}
        <div ref={headlineRef} className={`text-center transition-all duration-[520ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <h1 className="font-default font-bold uppercase text-foreground" style={{
          fontSize: "clamp(4rem, 13vw, 12rem)",
          letterSpacing: "-0.02em",
          lineHeight: "0.82"
        }}>
            <span className="block"><span className="!text-6xl">Start Ranking Higher with</span></span>
            <span className="block !text-6xl"><span className="relative inline-block"><span className="font-serif italic text-primary !text-6xl" style={{
                fontSize: '0.85em',
                letterSpacing: '0.01em'
              }}>Our SEO Strategy</span></span><span className="!text-6xl"><span className="relative inline-block" data-ast-id="f:/src/pages/Seo/sections/HeroSeoOverview.tsx|sig:yh4ngo" data-ast-start="4186" data-ast-end="5553"><span className="font-serif italic text-primary" data-ast-id="f:/src/pages/Seo/sections/HeroSeoOverview.tsx|sig:tf4vm" data-ast-start="4339" data-ast-end="4639" style={{
                  fontSize: '0.85em',
                  letterSpacing: '0.01em'
                }} contenteditable="false"></span><span aria-hidden="true" className="absolute left-0 right-0 -bottom-2 md:-bottom-3 origin-left flex items-center" data-ast-id="f:/src/pages/Seo/sections/HeroSeoOverview.tsx|sig:xyr3sr" data-ast-start="4639" data-ast-end="5546" style={{
                  transform: 'rotate(-6deg)'
                }}><span className="h-px bg-secondary transition-transform duration-700 ease-out origin-left scale-x-100" data-ast-id="f:/src/pages/Seo/sections/HeroSeoOverview.tsx|sig:csamem" data-ast-start="4939" data-ast-end="5226" style={{
                    width: '100%'
                  }}></span><span className="size-1.5 bg-secondary shrink-0 transition-all duration-300 opacity-100 scale-100" aria-hidden="true" data-ast-id="f:/src/pages/Seo/sections/HeroSeoOverview.tsx|sig:x8gq2k" data-ast-start="5226" data-ast-end="5539" style={{
                    transitionDelay: '700ms'
                  }}></span></span></span> oPTIMIZED for YOUR Business</span></span>
          </h1>
        </div>

        {}
        <div className={`mt-10 md:mt-14 text-center transition-all duration-[520ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionDelay: headlineVisible ? "160ms" : "0ms"
      }}>
          <p className="font-mono text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-muted-foreground"><span className="text-primary">ASAHI SEARCH — SEO AGENCY FOR SMBS</span></p>
        </div>

        {}
        <div ref={ctaRef} className={`mt-12 md:mt-16 flex justify-center transition-all duration-[520ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionDelay: ctaVisible ? "240ms" : "0ms"
      }}>
          <div className="relative group inline-block">
            <Button asChild className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 border-none px-9 py-6 h-auto font-default uppercase tracking-[0.04em] text-base md:text-lg transition-all duration-[180ms] ease-out relative z-10 group-hover:shadow-lg">
              <Link to="/ContactUsPage">Get a Free SEO Audit</Link>
            </Button>
            {}
            <span aria-hidden="true" className="absolute inset-0 bg-secondary -z-0 opacity-0 group-hover:opacity-100 transition-all duration-[180ms] ease-out translate-x-1 translate-y-1" />
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none overflow-hidden">
        <div className="relative h-6 flex items-center" style={{
        transform: "rotate(-6deg) translateY(0)"
      }}>
          <span className="h-px bg-primary flex-1" />
          <span className="size-1.5 bg-primary shrink-0 mr-4" aria-hidden="true" />
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}